<template>
  <section-main class="hero-section" :vertical-space="false">
    <hero-animation/>
  </section-main>
</template>

<script>
import HeroAnimation from '@/components/HeroAnimation'

export default {
  components: {
    HeroAnimation
  }
}
</script>

<style lang="scss" scoped>
  .hero-section {
    background-color: #fff !important;

    @include media-up(md) {
      background-color: #000 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Hero.vue